import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getCompanyAiValidationUrl, isCompanyAiEnabled } from "@/utils/companyAiAvailability";
import "./transitionNotice.css";

type RequireCompanyAiDeploymentProps = {
  children: JSX.Element;
  title?: string;
  message?: string;
};

export default function RequireCompanyAiDeployment({
  children,
  title = "Company AI now lives on the active AI PM deployment",
  message = "This legacy PM deployment is no longer maintained. Use aipm.linfinityeng.com for current PMApp and Company AI work.",
}: RequireCompanyAiDeploymentProps) {
  const navigate = useNavigate();
  const location = useLocation();

  if (isCompanyAiEnabled()) {
    return children;
  }

  const validationUrl = getCompanyAiValidationUrl(location.pathname, location.search, location.hash);

  return (
    <div className="transition-notice-shell">
      <div className="transition-notice-card">
        <div className="transition-notice-icon">🧠</div>
        <h1>{title}</h1>
        <p>{message}</p>
        <div className="transition-notice-actions">
          <a
            href={validationUrl}
            className="transition-notice-button transition-notice-button--primary"
          >
            Open Active AI PM Site
          </a>
          <button
            type="button"
            onClick={() => navigate("/")}
            className="transition-notice-button transition-notice-button--secondary"
          >
            Back to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
}
